import { Moment } from 'moment';

export class FilterModel {
    public firstName: string;
    public lastName: string;
    public consultantTypes: FilterItem[];
    public seniority: FilterItem[];
    public skills: FilterItem[];
    public tribes: FilterItem[];
    public hives: FilterItem[];
    public accountClusters: FilterItem[];
    public accounts: FilterItem[];
    public startDateFrom: Moment;
    public startDateTo: Moment;
    public peopleCoaches: FilterItem[];
    public profiles: FilterItem[];
    public quickFilters: FilterItem[];
    [key: string]: any; // Make TypeScript happy

    constructor() {
        this.firstName = '';
        this.lastName = '';
        this.consultantTypes = [];
        this.seniority = [];
        this.skills = [];
        this.tribes = [];
        this.hives = [];
        this.accountClusters = [];
        this.accounts = [];
        this.startDateFrom = null;
        this.startDateTo = null;
        this.peopleCoaches = [];
        this.profiles = [];
        this.quickFilters = [];
    }

    public updateFirstName(newValue: string) {
        this.firstName = newValue;
    }

    public updateLastName(newValue: string) {
        this.lastName = newValue;
    }

    public updateConsultantType(newItems: FilterItem[]) {
        this.consultantTypes = newItems.slice();
    }

    public updateSeniority(newItems: FilterItem[]) {
        this.seniority = newItems.slice();
    }

    public updateSkills(newItems: FilterItem[]) {
        this.skills = newItems.slice();
    }

    public updateTribes(newItems: FilterItem[]) {
        this.tribes = newItems.slice();
    }

    public updateHives(newItems: FilterItem[]) {
        this.hives = newItems.slice();
    }

    public updateAccounts(newItems: FilterItem[]) {
        this.accounts = newItems.slice();
    }

    public updateAccountClusters(newItems: FilterItem[]) {
        this.accountClusters = newItems.slice();
    }

    public updateStartDateFrom(newDate: Moment) {
        this.startDateFrom = newDate;
    }

    public updateStartDateTo(newDate: Moment) {
        this.startDateTo = newDate;
    }

    public updatePeopleCoaches(newItems: FilterItem[]) {
        this.peopleCoaches = newItems.slice();
    }

    public updateProfiles(newItems: FilterItem[]) {
        this.profiles = newItems.slice();
    }

    public updateQuickFilters(newItems: FilterItem[]) {
        this.quickFilters = newItems.slice();
    }

    public get activeFilters() {
        const activeFilters: { label: string; remove: () => void }[] = [];
        if (this.firstName) {
            activeFilters.push({ label: this.firstName, remove: () => (this.firstName = '') });
        }
        if (this.lastName) {
            activeFilters.push({ label: this.lastName, remove: () => (this.lastName = '') });
        }
        activeFilters.push(...this.mapToActiveFilter('consultantTypes'));
        activeFilters.push(...this.mapToActiveFilter('skills'));
        activeFilters.push(...this.mapToActiveFilter('seniority'));
        activeFilters.push(...this.mapToActiveFilter('tribes'));
        activeFilters.push(...this.mapToActiveFilter('hives'));
        activeFilters.push(...this.mapToActiveFilter('accounts'));
        activeFilters.push(...this.mapToActiveFilter('accountClusters'));
        activeFilters.push(...this.mapToActiveFilter('peopleCoaches'));
        activeFilters.push(...this.mapToActiveFilter('profiles'));
        activeFilters.push(...this.mapToActiveFilter('quickFilters'));
        if (this.startDateFrom) {
            activeFilters.push({ label: this.startDateFrom.format('DD/MM/YYYY'), remove: () => (this.startDateFrom = null) });
        }
        if (this.startDateTo) {
            activeFilters.push({ label: this.startDateTo.format('DD/MM/YYYY'), remove: () => (this.startDateTo = null) });
        }

        return activeFilters;
    }

    public isEmpty() {
        return this.activeFilters.length === 0;
    }

    public clear() {
        this.updateFirstName('');
        this.updateLastName('');
        this.updateConsultantType([]);
        this.updateSeniority([]);
        this.updateSkills([]);
        this.updateTribes([]);
        this.updateHives([]);
        this.updateAccounts([]);
        this.updateAccountClusters([]);
        this.updateStartDateFrom(null);
        this.updateStartDateTo(null);
        this.updatePeopleCoaches([]);
        this.updateProfiles([]);
        this.updateQuickFilters([]);
    }

    public copyTo(copy: FilterModel) {
        if (!copy) {
            return;
        }
        copy.updateFirstName(this.firstName);
        copy.updateLastName(this.lastName);
        copy.updateConsultantType(this.consultantTypes);
        copy.updateSeniority(this.seniority);
        copy.updateSkills(this.skills);
        copy.updateTribes(this.tribes);
        copy.updateHives(this.hives);
        copy.updateAccounts(this.accounts);
        copy.updateAccountClusters(this.accountClusters);
        copy.updateStartDateFrom(this.startDateFrom);
        copy.updateStartDateTo(this.startDateTo);
        copy.updatePeopleCoaches(this.peopleCoaches);
        copy.updateProfiles(this.profiles);
        copy.updateQuickFilters(this.quickFilters);
    }

    private mapToActiveFilter(key: 'consultantTypes' | 'seniority' | 'skills' | 'tribes' | 'hives' | 'accounts' | 'accountClusters' | 'peopleCoaches' | 'profiles' | 'quickFilters') {
        return this[key].map((item, index) => {
            return {
                label: item.label,
                remove: () => {
                    this[key].splice(index, 1);
                }
            };
        });
    }
}

export enum ConsultantType {
    Technical = 'Technical',
    NonTechnical = 'Non-Technical'
}

export enum QuickFilter {
    NewHires = 'New Hires',
}

export class FilterItem {
    constructor(public label: string, public value: string) {}
}
